exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-directmessaging-new-window{height:400px}.asseco-directmessaging-window-tbar{top:3px;height:35px!important;padding:5px;border-bottom:1px solid rgba(0,0,0,.1);background-color:#fafafa}", ""]);

// exports
